/* eslint-disable no-console */
import { formatInDollars } from './utils/string-utils';

export default class EasyShadeOrdering {
  constructor() {
    this.priceListUrl = window.getPriceListUrl;
    this.getModelAndHousingCodesUrl = window.getModelAndHousingCodesUrl;
    this.itemPrefix = window.itemPrefix;
    this.priceList = {};
    this.lineItemSelectors = document.querySelectorAll('.easyshade-line-item .form-select');
    this.lineItemInputs = document.querySelectorAll('.easyshade-line-item .form-control');
    this.ppoIpts = document.querySelectorAll('.line-item-price-per-order');
    this.qtyIpts = document.querySelectorAll('.line-item-quantity');
    this.lineItemsEnteredIpt = document.getElementById('LineItemsEntered');
    this.orderItems = [];
    this.modelHousingCodes = [];
    this.addToCartRedirectUrl = window.addToCartRedirectUrl;

    const that = this;
    const resetBtn = document.querySelector('.reset-btn');
    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        that.resetLineItems();
      });
    }

    this.getPriceListData()
      .then((data) => {
        this.priceList = data;
        this.onPriceListDataLoaded();
      });
  }

  getPriceListData() {
    return new Promise((resolve, reject) => {
      fetch(this.priceListUrl, {
        method: 'GET',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
      })
        .then((response) => {
          if (response.ok) {
            response.json().then(resolve);
          } else {
            response.json().then(reject);
          }
        })
        .catch(console.error);
    });
  }

  getPriceByModelSize(model, size) {
    let price = -1;
    if (size === '' || model === '') {
      return price;
    }
    const item = this.priceList.find(p => p.Size === size);
    if (item !== undefined) {
      switch (model) {
        case '0':
          price = parseFloat(item.PriceM, 10);
          break;
        case '1':
        case '2':
          price = parseFloat(item.PriceO, 10);
          break;
        case '3':
          price = parseFloat(item.PriceS, 10);
          break;
        default:
      }
    }
    return price;
  }

  updateLineItemsEntered() {
    let qty = 0;
    [].map.call(this.ppoIpts, (ipt) => {
      if (ipt.value !== '') {
        qty += 1;
      }
    });
    if (this.lineItemsEnteredIpt) {
      this.lineItemsEnteredIpt.value = qty;
    }
  }

  onLineItemUpdated(lineItem) {
    const sizeVal = lineItem.querySelector('.line-item-size').value;
    const modelVal = lineItem.querySelector('.line-item-model').value;
    const qtyVal = lineItem.querySelector('.line-item-quantity').value;
    const formattedPpoIpt = lineItem.querySelector('.line-item-formatted-price-per-order');
    const ppoIpt = lineItem.querySelector('.line-item-price-per-order');
    const price = this.getPriceByModelSize(modelVal, sizeVal);
    if (qtyVal !== '' && qtyVal !== '0' && price !== -1) {
      ppoIpt.value = (price * parseInt(qtyVal, 10)).toFixed(2);
      formattedPpoIpt.value = formatInDollars(price * parseInt(qtyVal, 10));
    } else {
      formattedPpoIpt.value = '';
      ppoIpt.value = '';
    }
    this.updateLineItemsEntered();
  }

  onPriceListDataLoaded() {
    [].map.call(this.lineItemSelectors, selector => (
      selector.addEventListener('change', (event) => {
        const lineItem = event.target.closest('tr');
        this.onLineItemUpdated(lineItem);
      })
    ));
    [].map.call(this.lineItemInputs, input => (
      input.addEventListener('keyup', (event) => {
        const lineItem = event.target.closest('tr');
        this.onLineItemUpdated(lineItem);
      })
    ));
    // Calculate prices on load, if quantities are already set
    [].map.call(this.qtyIpts, (ipt) => {
      if (ipt.value !== '' && ipt.value !== '0') {
        const lineItem = ipt.closest('tr');
        this.onLineItemUpdated(lineItem);
      }
    });
  }

  resetLineItems() {
    [].map.call(this.lineItemSelectors, (selector) => {
      // Set selected to first value
      const firstOption = selector.querySelector('option:first-child');
      if (firstOption) {
        selector.value = firstOption.getAttribute('value');
      }
    });
    [].map.call(this.lineItemInputs, (input) => {
      input.value = '';
    });
  }
}
window.EasyShadeOrdering = EasyShadeOrdering;
/* eslint-enable no-console */
